<div
  id="integrations"
  class="settings-page-container"
  rvSpinner="integrations-deeplink"
  [rvShowSpinner]="deepLinkLoading()"
  [attr.aria-busy]="deepLinkLoading() ? 'true' : null"
>
  <div class="settings-page-body">
    <div class="integrations-content">
      <integrations-user-section></integrations-user-section>
      @if (companyAccessService.accessCompanyIntegrations) {
        <integrations-company-section
          [initialLoading]="companyInitialLoading()"
          [actionLoading]="companyActionLoading()"
        ></integrations-company-section>
        <integrations-company-add-section
          [initialLoading]="companyInitialLoading()"
          [actionLoading]="companyActionLoading()"
        ></integrations-company-add-section>
      }
    </div>
  </div>
</div>
